/**
 * Sanitize URL to prevent XSS attacks and ensure proper URL format
 * @param url - URL string to sanitize
 * @returns Sanitized URL string or empty string if invalid
 */
export const sanitizeUrl = (url: string): string => {
  // Return empty string for null, undefined or non-string inputs
  if (!url) return '';

  // Remove whitespace from the beginning and end of the URL
  url = url.trim();

  // Ensure the URL starts with http:// or https:// protocol
  // If no protocol is specified, default to https://
  if (!/^https?:\/\//i.test(url)) {
    url = 'https://' + url;
  }

  try {
    // Validate URL format using the built-in URL constructor
    const parsedUrl = new URL(url);

    // Block potentially dangerous protocols (only allow http: and https:)
    // This prevents JavaScript:, data:, file: and other unsafe protocols
    if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
      console.warn('Blocked unsafe URL protocol:', parsedUrl.protocol);
      return '';
    }

    // Return the sanitized and validated URL
    return parsedUrl.toString();
  } catch (e) {
    // If URL parsing fails, log a warning and return an empty string
    // This handles malformed URLs that could potentially be used for attacks
    console.warn('Invalid URL format:', url);
    return '';
  }
};
